import { Chart, registerables } from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import 'react-date-range/dist/styles.css' // main css file
import 'react-date-range/dist/theme/default.css'
// import ReactDom from 'react-dom'
// import ReactDOM from 'react-dom'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import 'react-grid-layout/css/styles.css'
import 'react-resizable/css/styles.css'
import App from './Components/App'
import './index.css' // or 'rsuite/dist/rsuite.min.css'
import './i18n' // LAP-733 (GE022) — initialise i18next early
Chart.register(...registerables) // theme css file
// ChartJS.register(ArcElement, CategoryScale);
Chart.register(ChartDataLabels)
// const root = ReactDOM.createRoot(document.getElementById('root'))

// ReactDOM.render(
//   <BrowserRouter>
//     <App />
//   </BrowserRouter>,

//   document.getElementById('root'),
// )

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
)
